import firebase from './Firebase';

const remoteConfig = firebase.remoteConfig();

remoteConfig.settings = {
  minimumFetchIntervalMillis: 60,
  fetchTimeoutMillis: 2000,
};

export default remoteConfig;
